import { GetAllCustomersInDto } from '../../../types/customer.dto'

export const GET_ALL_CUSTOMERS_STATICS = 'GET_ALL_CUSTOMERS_STATICS'
export const GET_ALL_CUSTOMERS_STATICS_SUCCESS = 'GET_ALL_CUSTOMERS_STATICS_SUCCESS'
export const GET_ALL_CUSTOMERS_STATICS_ERROR = 'GET_ALL_CUSTOMERS_STATICS_ERROR'
export const RESET_GET_ALL_CUSTOMERS_STATICS = 'RESET_GET_ALL_CUSTOMERS_STATICS'

export interface GetAllCustomersStatics {
  type: typeof GET_ALL_CUSTOMERS_STATICS
  payload: null
}

export interface GetAllCustomersStaticsSuccess {
  type: typeof GET_ALL_CUSTOMERS_STATICS_SUCCESS
  payload: GetAllCustomersInDto
}

export interface GetAllCustomersStaticsError {
  type: typeof GET_ALL_CUSTOMERS_STATICS_ERROR
  payload: string | boolean
}

export interface ResetGetAllCustomersStatics {
  type: typeof RESET_GET_ALL_CUSTOMERS_STATICS
  payload: null
}

export interface State {
  data: GetAllCustomersInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllCustomersStatics
  | GetAllCustomersStaticsSuccess
  | GetAllCustomersStaticsError
  | ResetGetAllCustomersStatics
